import React from "react";
import { useIntl } from "react-intl";

import SelectLabel from "src/app/components/Select/components/SelectLabel/SelectLabel";
import { translateMessage } from "src/app/methods/translateMessage";
import { ReactComponent as NavigationIcon } from "src/images/navigation.svg";

import "./OutreachCount.scss";

interface OutreachCountProps {
  handleOpenMessageHistoryPreview: () => void;
  value: string;
}

export default function OutreachCount({
  handleOpenMessageHistoryPreview,
  value,
}: OutreachCountProps) {
  const intl = useIntl();

  const valueNumber = parseInt(value, 10);

  const name = `${translateMessage({
    intl,
    id: "ws_message_sent",
    defaultMessage: "Message sent",
  })} ${valueNumber > 1 ? `(${value})` : ""}`;
  return (
    <button
      className="outreach-count button-style-reset"
      onClick={handleOpenMessageHistoryPreview}
      disabled={valueNumber === 0}
      type="button"
    >
      {valueNumber > 0 ? (
        <>
          <SelectLabel
            emptyFieldPlaceholder={null}
            value={{
              name,
              rank: "aaa",
              color: "5A607C",
              backgroundColor: "F2F2F6",
              value,
            }}
          />
          <NavigationIcon className="outreach-count__btn" />
        </>
      ) : (
        "-"
      )}
    </button>
  );
}
